import { InterruptionDto, InterruptionEmployeeResponseStatus, InterruptionViewStatus } from './domain';

export enum InterruptionsActionType {
  Reset = 'RESET_INTERRUPTION_STATE',
  SetInterruptionsRequest = 'SET_INTERRUPTION_REQUEST',
  SetInterruptionsSuccess = 'SET_INTERRUPTION_SUCCESS',
  SetInterruptionsFailure = 'SET_INTERRUPTION_FAILURE',
  AddInterruption = 'ADD_INTERRUPTION',
  RemoveInterruption = 'REMOVE_INTERRUPTION',
  SetInterruptionResponseStatus = 'SET_INTERRUPTION_RESPONSE_STATUS',
  SetInterruptionsViewStatus = 'SET_INTERRUPTION_VIEW_STATUS',
  SetEmergencyInterruptionsRequest = 'SET_EMERGENCY_INTERRUPTION_REQUEST',
  SetEmergencyInterruptionsSuccess = 'SET_EMERGENCY_INTERRUPTION_SUCCESS',
  MergeEmergencyInterruptionsSuccess = 'MERGE_EMERGENCY_INTERRUPTION_SUCCESS',
  SetEmergencyInterruptionsFailure = 'SET_EMERGENCY_INTERRUPTION_FAILURE',
  RemoveEmergencyInterruption = 'REMOVE_EMERGENCY_INTERRUPTION',
  AddEmergencyInterruption = 'ADD_EMERGENCY_INTERRUPTION',
}

type SetInterruptionResponseStatusPayload = {
  id: string;
  employeeResponseStatus: InterruptionEmployeeResponseStatus;
};

export type SetInterruptionsViewStatusPayload = {
  ids: string[];
  viewStatus: InterruptionViewStatus;
};

export type InterruptionsState = {
  emergencyError: Nullable<string>;
  emergencyInterruptions: InterruptionDto[];
  emergencyLoading: boolean;
  error: Nullable<string>;
  listInterruptions: InterruptionDto[];
  loading: boolean;
};

export type InterruptionsAction =
  | { type: InterruptionsActionType.Reset }
  | { type: InterruptionsActionType.SetInterruptionsRequest }
  | { payload: InterruptionDto[]; type: InterruptionsActionType.SetInterruptionsSuccess }
  | { payload: string; type: InterruptionsActionType.SetInterruptionsFailure }
  | { payload: InterruptionDto; type: InterruptionsActionType.AddInterruption }
  | { payload: string; type: InterruptionsActionType.RemoveInterruption }
  | {
      payload: SetInterruptionResponseStatusPayload;
      type: InterruptionsActionType.SetInterruptionResponseStatus;
    }
  | { payload: SetInterruptionsViewStatusPayload; type: InterruptionsActionType.SetInterruptionsViewStatus }
  | { type: InterruptionsActionType.SetEmergencyInterruptionsRequest }
  | { payload: InterruptionDto[]; type: InterruptionsActionType.SetEmergencyInterruptionsSuccess }
  | { payload: InterruptionDto[]; type: InterruptionsActionType.MergeEmergencyInterruptionsSuccess }
  | { payload: string; type: InterruptionsActionType.SetEmergencyInterruptionsFailure }
  | { payload: string; type: InterruptionsActionType.RemoveEmergencyInterruption }
  | { payload: InterruptionDto; type: InterruptionsActionType.AddEmergencyInterruption };
